import { DP, IQ, NEO, PM, VP } from "./EventFileTypes";

export const EVENTS_TYPE_NEO = "NEO";
export const EVENTS_TYPE_PM = "PM";
export const EVENTS_TYPE_DP = "Dual path";
export const EVENTS_TYPE_VP = "Virtual panel";
export const EVENTS_TYPE_IQ = "IQ";

export const EVENT_TITLE_TO_TYPE_MAP = {
  [EVENTS_TYPE_PM]: PM,
  [EVENTS_TYPE_NEO]: NEO,
  [EVENTS_TYPE_DP]: DP,
  [EVENTS_TYPE_VP]: VP,
  [EVENTS_TYPE_IQ]: IQ,
};
